import { createApp } from 'https://unpkg.com/vue@3/dist/vue.esm-browser.prod.js';

const app = createApp({
  data() {
    return {
      selectedColorSwatchButton: null,
      currentProductId: null,
      currentVariantId: null,
      variantSelection: [],
      products: [],
      variantOptions: [],
      slickSlider: null,
      slickSliderNav: null,
      imageGallery: null,
      variantExists: true,
    }
  },
  computed: {
    currentProduct() {
      return this.products.filter(product => product.product.id == this.currentProductId)[0];
    },
    currentVariant() {
      let currentVariant;

      this.products.forEach(product => {
        const tempCurrentVariant = product.product.variants.filter(variant => variant.id == this.currentVariantId);
        if (tempCurrentVariant.length > 0) {
          currentVariant = tempCurrentVariant;
        }
      });

      return currentVariant[0];
    }
  },
  methods: {
    log(item) {
      console.log('item', item);
    },
    galleryZoom(evt) {
      evt.preventDefault();

      const pswpElement = document.querySelectorAll('.pswp')[0];
      const productImages = $(this.$refs.productGallery).find("[data-product-image]");
      let items = [];

      productImages.each(function (index) {

        $(this).data('image-index', index);

        var item = {
          src: $(this).attr('href'),
          w: $(this).data('image-w'),
          h: $(this).data('image-h')
        };

        var img = $(this).find('img')[0];

        if (typeof img.currentSrc !== 'undefined') {
          item.msrc = img.currentSrc;
        }
        items.push(item);
      });

      var options = {
        history: false,
        captionEl: false,
        shareEl: false,
        fullscreenEl: false
      };

      console.log('items', items);

      // use event target to determine which image to launch first
      options.index = $(evt.target).closest('a').data('image-index');
      options.getThumbBoundsFn = function (index) {
        var thumbnail = productImages[index].getElementsByTagName('img')[0],
        pageYScroll = window.scrollY || document.documentElement.scrollTop,
        rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      };
      this.imageGallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      this.imageGallery.init();

      this.imageGallery.listen('destroy', () => {
        this.imageGallery = null;
      });

      const _this = this;

      console.log('this.imageGallery', this.imageGallery);

      this.imageGallery.listen('afterChange', function () {
        var currentSrc = this.currItem.src;
        var $currentThumb = productImages.filter(function () {
          return $(this).attr('href') == currentSrc;
        });
        _this.updatePrimaryProductMediaFromThumbnail(productImages, $currentThumb);
      });
    },
    updatePrimaryProductMediaFromThumbnail(productImages, $currentThumb) {
      if (this.slickSlider.hasClass('slick-slider')) {
        var index = productImages.filter('[data-media-id="' + $currentThumb.data('media-id') + '"]').closest('.slick-slide').data('slick-index');
        this.slickSlider.slick('slickGoTo', index);
      }
    },
    galleryLoad() {
      this.$nextTick(() => {

        if (this.slickSlider === null) {
          this.slickSlider = $(this.$refs.productGallery).slick({
            infinite: true,
            fade: true,
            arrows: false,
            dots: false,
            adaptiveHeight: true,
            waitForAnimate: false,
            responsive: [
              {
                breakpoint: 767.98,
                settings: {
                  fade: false,
                  arrows: true,
                  dots: true
                }
              }
            ]
          });
        }

        if (this.slickSliderNav === null) {
          this.slickSliderNav = $(this.$refs.productGalleryNav).slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: this.$refs.productGallery,
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: true,
            appendArrows: this.$refs.productGalleryNavArrows,
          });
        }
      });
    },
    productIsNotAvailable(index) {
      let productIsAvailable = false;
      for (var variantIndex = 0; variantIndex < this.products[index].product.variants.length; variantIndex++) {
        var variant = this.products[index].product.variants[variantIndex];
        if (variant.available && (this.variantSelection[0] === variant.option1 || this.variantSelection[0] === "") && (this.variantSelection[1] === variant.option2 || this.variantSelection[1] === "") && (this.variantSelection[2] === variant.option3 || this.variantSelection[2] === "")) {
          productIsAvailable = true;
        }
      }
      return productIsAvailable;
    },
    variantIsNotAvailable(value, parentIndex) {
      for (var optionIndex = 0; optionIndex < this.currentProduct.product.options.length; optionIndex++) {
        // list each value for this option
        var optionValues = {};
        for (var variantIndex = 0; variantIndex < this.currentProduct.product.variants.length; variantIndex++) {
          var variant = this.currentProduct.product.variants[variantIndex];
          if (typeof optionValues[variant.options[optionIndex]] === 'undefined') {
            optionValues[variant.options[optionIndex]] = false;
          }
          // mark true if an option is available
          if (optionIndex == 1) {
            const matchedVariant = this.currentProduct.product.variants.filter(variant => variant.option1 == this.currentVariant.option1 && variant.option2 == value)[0];
            if (matchedVariant && matchedVariant.available) {
              optionValues[variant.options[optionIndex]] = true;
            }
          } else if (variant.available) {
            optionValues[variant.options[optionIndex]] = true;
          }
        }

        if (optionIndex === parentIndex && (!optionValues[value] || !optionValues.hasOwnProperty(value))) {
          return true;
        }

        // console.log('optionValues', optionValues)
        // console.log('value', value)
        // // mark any completely unavailable options
        // for (var key in optionValues) {
        //   if (!optionValues[key] && key == value) {
        //     return true;
        //   }
        // }
      }
    },
    imgURL(src, size, center = false) {
      if (!src || typeof src === 'undefined') return

      // Remove any current image size then add the new image size
      let count = (src.match(/\.jpg|\.png|\.gif|\.jpeg/g) || []).length;
      let centerVal = '';

      if (center) {
        centerVal = '_crop_center';
      }
      if (src === null) {
        return
      }
      if (count > 1) {
        return src
      }

      return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, match => {
          return '_' + size + centerVal + match
        })
    },
    submitAddToCartForm(e) {

      var $input = $('.qty-actual').find('[name="quantity"]');
      var qty = $input.val();

      fetch(theme.routes.cart_add_url + '.js', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              quantity: qty,
              id: this.currentVariant.id
            }
          ]
        }),
      })
      .then((response) => {
        if(response.ok) {
          return response.json();
        }
        return response.json().then(res => {throw new Error(res.description)})
      })
      .then((itemData) => {

        var itemData = itemData.items[0];

        $.get(theme.routes.search_url, function (searchData) {
          var selectors = [
          '.page-header .header-cart',
          '.docked-navigation-container .header-cart'];

          var $parsed = $($.parseHTML('<div>' + searchData + '</div>'));
          for (var i = 0; i < selectors.length; i++) {
            var cartSummarySelector = selectors[i];
            var $newCartObj = $parsed.find(cartSummarySelector).clone();
            var $currCart = $(cartSummarySelector);
            $currCart.replaceWith($newCartObj);
          }
        });

        var productPrice = '';
        if (itemData.original_line_price > itemData.final_line_price) {
          productPrice += '<span class="cart-summary__price-reduced product-price__reduced theme-money">' + theme.Shopify.formatMoney(itemData.final_line_price, theme.moneyFormat) + '</span>';
          productPrice += '<span class="cart-summary__price-compare product-price__compare theme-money">' + theme.Shopify.formatMoney(itemData.original_line_price, theme.moneyFormat) + '</span>';
        } else {
          productPrice += '<span class="theme-money">' + theme.Shopify.formatMoney(itemData.final_line_price, theme.moneyFormat) + '</span>';
        }
        if (itemData.unit_price) {
          productPrice += '<span class="cart-summary__unit-price unit-price theme-money">' + theme.Shopify.formatMoney(itemData.unit_price, theme.moneyFormat) + theme.strings.unitPriceSeparator + itemData.unit_price_measurement.reference_unit + '</span>';
        }

        // append quantity
        var productQty = '';
        if (itemData.quantity > 1) {
          productQty = ' <span class="cart-summary__quantity">' + itemData.quantity + '</span>';
        }

        // append preorder text
        var productPreorderHTML = '';
        var $form = $('.ajax-product-form');
        if ($form.parent()[0].hasAttribute('data-preorder')) {
          productPreorderHTML = ' <span class="cart-summary__preorder">' + theme.strings.productPreorder + '</span>';
        }

        if (itemData.line_level_discount_allocations && itemData.line_level_discount_allocations.length > 0) {
          productPrice += '<ul class="cart-discount-list small-text">';
          for (var i = 0; i < itemData.line_level_discount_allocations.length; i++) {
            var discount_allocation = itemData.line_level_discount_allocations[i];
            productPrice += [
            '<li class="cart-discount">',
            '<div class="cart-discount__label">',
            discount_allocation.discount_application.title,
            '</div>',
            '<div class="cart-discount__amount theme-money">',
            theme.Shopify.formatMoney(discount_allocation.amount, theme.moneyFormat),
            '</div>',
            '</li>'].join('');
          }
          productPrice += '</ul>';
        }
        var sellingPlanHTML = '';
        if (itemData.selling_plan_allocation && itemData.selling_plan_allocation.selling_plan.name) {
          sellingPlanHTML = [
          '<div class="cart-summary__selling-plan ">',
          itemData.selling_plan_allocation.selling_plan.name,
          '</div>'].join('');
        }

        var productVariantsHTML = '';
        if (this.currentVariant) {
          // get option names from full product data
          var optionNames = this.currentProduct.product.options;
          productVariantsHTML = '<div class="cart-summary__product__variants">';
          for (var i = 0; i < this.currentVariant.options.length; i++) {
            if (this.currentVariant.options[i].indexOf('Default Title') < 0) {
              productVariantsHTML += '<div class="cart-summary__variant">';
              productVariantsHTML += '<span class="cart-summary__variant-label">' + optionNames[i] + ':</span> ';
              productVariantsHTML += '<span class="cart-summary__variant-value">' + this.currentVariant.options[i] + '</span>';
              productVariantsHTML += '</div>';
            }
          }
          productVariantsHTML += '</div>';
        }

        var productImage;
        if (this.currentVariant.featured_media) {
          productImage = slate.Image.getSizedImageUrl(this.currentVariant.featured_media.preview_image.src, '200x');
        } else if (this.currentProduct.product.media && this.currentProduct.product.media.length > 0) {
          productImage = slate.Image.getSizedImageUrl(this.currentProduct.product.media[0].preview_image.src, '200x');
        }

        var currentProduct = this.currentProduct.product;

        // additional fetch - for full cart data
        $.getJSON(theme.routes.cart_url + '.js', function (cartData) {
          var $template = $([
          '<div class="added-notice global-border-radius added-notice--pre-reveal">',
          '<div class="added-notice__header">',
          '<span class="added-notice__title">', theme.strings.addedToCartPopupTitle, '</span>',
          '<a class="added-notice__close feather-icon" href="#" aria-label="', theme.strings.close, '">', theme.icons.close, '</a>',
          '</div>',
          '<div class="cart-summary global-border-radius">',
          '<div class="cart-summary__product">',
          '<div class="cart-summary__product-image"><img class="global-border-radius" src="', productImage, '" role="presentation" alt=""></div>',
          '<div class="cart-summary__product__description">',
          '<div class="cart-summary__product-title">', currentProduct.title, productQty, '</div>',
          productVariantsHTML,
          productPreorderHTML,
          sellingPlanHTML,
          '<div class="cart-summary__price">', productPrice, '</div>',
          '</div>',
          '</div>',
          '</div>',
          '<div class="cart-summary__footer">',
          '<div class="cart-summary__total-quantity-row">',
          '<span>', theme.strings.addedToCartPopupItems, '</span>',
          '<span>', cartData.item_count, '</span>',
          '</div>',
          '<div class="cart-summary__total-price-row large-text">',
          '<span>', theme.strings.addedToCartPopupSubtotal, '</span>',
          '<span class="theme-money">', theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormatWithCodeForCartPreference), '</span>',
          '</div>',
          '<a href="', theme.routes.cart_url, '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">', theme.strings.addedToCartPopupGoToCart, '</a>',
          '</div>',
          '</div>'].
          join(''));
          $template.appendTo('body');

          $(document).on('click.ajaxAddToCart', '.added-notice__close', function () {
            var $template = $(this).closest('.added-notice').addClass('added-notice--pre-destroy');
            setTimeout(function () {
              $template.remove();
            }, 500);
            return false;
          });

          // transition in
          setTimeout(function () {
            $template.removeClass('added-notice--pre-reveal');
          }, 10);

          // transition out
          theme.addedToCartNoticeHideTimeoutId = setTimeout(function () {
            $template.find('.added-notice__close').trigger('click');
            $(document).off('.ajaxAddToCart');
            clearTimeout(theme.addedToCartNoticeHideTimeoutId);
          }, 5000);
          
        });
      })
      .catch((error) => {

        var $popup = $('<div class="simple-popup"/>');
        var $origin = $(e.target);
        var offs = $origin.offset();
        $popup.html(error).css({ 'left': offs.left, 'top': offs.top }).hide();
        $('body').append($popup);
        $popup.css({ marginTop: -$popup.outerHeight() - 10, marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2 });
        $popup.fadeIn(200).delay(3500).fadeOut(400, function () {
          $(this).remove();
        });
      });
    },
    formatMoney(price) {
      return Shopify.formatMoney(price, "${{amount}}");
    },
    setSelectedColorSwatchButton(index) {
      this.selectedColorSwatchButton = index;
    },
    setCurrentProduct(id, url) {
      this.currentProductId = id;
      this.products.forEach(product => {
        if (product.product.id == this.currentProductId) {
          const tempVariant = product.product.variants.find((variant) => {
            var match = true;

            if(variant.option1 !== null) {
              match = variant.option1 == this.variantSelection[0];
            }
            if(match && variant.option2 !== null) {
              match = variant.option2 == this.variantSelection[1];
            }
            if(match && variant.option3 !== null) {
              match = variant.option3 == this.variantSelection[2];
            }
            return match;
          });

          if (!tempVariant) {
            this.variantSelection[0] = this.currentProduct.currentVariant.option1 || "";
            this.variantSelection[1] = this.currentProduct.currentVariant.option2 || "";
            this.variantSelection[2] = this.currentProduct.currentVariant.option3 || "";
          }
        }
      });
      $(this.$refs.productGallery).slick('slickRemove', null, null, true);
      $(this.$refs.productGalleryNav).slick('slickRemove', null, null, true);
      $(this.$refs.productGallery).slick('unslick');
      $(this.$refs.productGalleryNav).slick('unslick');
      this.setCurrentVariant();
      this.update_history_state('product', url);
    },
    setCurrentVariant() {
      let currentVariantId;

      this.products.forEach(product => {
        if (product.product.id == this.currentProductId) {
          const tempVariant = product.product.variants.find((variant) => {
            var match = true;

            if(variant.option1 !== null) {
              match = variant.option1 == this.variantSelection[0];
            }
            if(match && variant.option2 !== null) {
              match = variant.option2 == this.variantSelection[1];
            }
            if(match && variant.option3 !== null) {
              match = variant.option3 == this.variantSelection[2];
            }
            return match;
          });

          if (tempVariant) {
            currentVariantId = tempVariant.id;
            this.variantExists = true;
          } else {
            this.variantExists = false;
            currentVariantId = this.currentProduct.currentVariant.id;
          }
        }
      });

      this.currentVariantId = currentVariantId;
      this.update_history_state('variant', currentVariantId);
    },
    update_history_state(type, value) {
      if(!history.replaceState || !value) {
        return;
      }

      if (type === 'product') {
        var newurl = window.location.protocol + '//' + window.location.host + value;
        window.history.replaceState({path: newurl}, '', newurl);
      } else if (type === 'variant') {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + value;
        window.history.replaceState({path: newurl}, '', newurl);
      }
    }
  },
  created() {
    this.selectedColorSwatchButton = window.productVueObject.selectedColorSwatchButton;
    this.currentProductId = window.productVueObject.currentProductId;
    this.currentVariantId = window.productVueObject.currentVariantId;
    this.variantSelection = window.productVueObject.variantSelection;
    this.products = window.productVueObject.products;
    this.variantOptions = this.variantOptions = [[...window.productVueObject.variantOptions[0].sort((a, b) => {
      let firstEl = a;
      let secondEl = b;

      if (isNaN(firstEl) && a.match(/\d/g)) {
        firstEl = a.match(/\d/g).join('');
      }

      if (isNaN(secondEl) && b.match(/\d/g)) {
        secondEl = b.match(/\d/g).join('');
      }

      if (isNaN(firstEl) && a.match(/[a-z]/g) && isNaN(secondEl) && b.match(/[a-z]/g)) {

        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      } else {
        return parseFloat(firstEl) - parseFloat(secondEl)
      }
    })], [...window.productVueObject.variantOptions[1].sort()]];
  },
  updated() {

    $(this.$refs.productGallery).not('.slick-initialized').slick({
      infinite: true,
      fade: true,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      waitForAnimate: false,
      responsive: [
        {
          breakpoint: 767.98,
          settings: {
            fade: false,
            arrows: true,
            dots: true
          }
        }
      ]
    });

    $(this.$refs.productGalleryNav).not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: this.$refs.productGallery,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: true,
      appendArrows: this.$refs.productGalleryNavArrows,
    });
  }
});

app.mount('#product-page');
